import queryString from 'query-string';
import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import API from '@sesame/web-api';

import Alert, { AlertTypes } from 'src/components/AlertDisplay';

import { EditSalesorderDetails } from './Salesorder/EditSalesorderDetails';
import { SalesorderTable } from './SalesorderTable/SalesorderTable';

import { ILoadState, ISalesorder } from 'src/types';
import { Spinner } from 'src/components/Spinner';



export default function SalesordersList() {
  const {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0()


  const [displayState, setDisplayState] = useState<ILoadState>(ILoadState.NEW);
  const [salesordersList, setSalesordersList] = useState<ISalesorder[]>([]);

  const getSalesorders = async () => {
    if (isLoading) {
      return;
    }
    getAccessTokenSilently().then( accessToken => {
    API.get( accessToken, 'api/v1/salesorder')
      .then((response) => {
        setSalesordersList(response.data as ISalesorder[]);
        setDisplayState(ILoadState.READY);
      })
      .catch((err) => {
        if (err.status === 404) {
          Alert(AlertTypes.ERROR, 'Not Found');
          setDisplayState(ILoadState.NOTFOUND);
          return;
        }
        setDisplayState(ILoadState.NEW);
        Alert(AlertTypes.ERROR, err.message);
      });
    });
    setDisplayState(ILoadState.LOADING);
  }

  const onEditSave = () => {
    getSalesorders();
  }


  React.useEffect(() => {
    getSalesorders();
  }, [getAccessTokenSilently]);

  if (isLoading) {
    return <div><Spinner/></div>
  }


  return (
    <div className="uk-margin-small uk-margin-left uk-margin-right" >
      <h2> Salesorders </h2>
      <div className="uk-align-right">
        <EditSalesorderDetails onSave={onEditSave} />
      </div>
      <div className="uk-align-left uk-grid" >
        <div className="uk-align-left">
          {(displayState === ILoadState.NEW || displayState === ILoadState.LOADING) ? 
              <div><span data-uk-spinner className="uk-position-center" /></div>
          :
            <SalesorderTable salesordersList={salesordersList} />
          }
        </div>
      </div>
    </div>
  );
}
